var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.deliveryMethods),function(deliveryMethod,index){return [_c('DeliveryMethodsListItem',_vm._g({key:index,attrs:{"delivery-method":deliveryMethod}},_vm.$listeners))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }